<template>
  <div class="apply_container">
    <div class="header_img">
      <img
        src="https://faststatic.ccnfgame.com/cos/vrshow/a2478bade007269fc0c7236a423bd5b9.jpg"
      />
    </div>
    <div class="form_item">
        <van-field
        v-model="mobile"
        required
        label="手机号Mobile"
        placeholder="请输入内容"
    />
    </div>
    <div class="form_item my_btn">
            <van-button type="info"  @click="handelSubmit">确认CONFIRM</van-button>
        </div>

  </div>

</template>

<script>
import {login} from "@/common/api/media.js";
export default {
    data(){
        return{
            mobile:'',
            applyDetail:''
        }
    },
    methods:{
        handelSubmit(){
        login({
                mobile: this.mobile,
                activityId: "1711272035105398785",
                code: "882288"
            }).then(res=>{
                localStorage.setItem('applyDetail',JSON.stringify(res.data.entity.tickets[0]))
                this.$router.push({path:'/foreignMedia'})
            })
        }
    }
    
}
</script>

<style lang="scss" scoped>
.apply_container {
    width: 552px;
   min-height: 100vh;
    margin: 0 auto;
  .header_img {
    width: 100%;
    // width: 5rem;
    img {
      width: 100%;
    }
  }
  .form_item{
      margin-top:20px;
      width: 100%;
  }
  .my_btn{
        margin-top:520px;
        width: 100%;
        display: flex;
        justify-content: center;
    
  }
}

@media screen and (min-width: 100px) and (max-width: 1000px) {
  .apply_container{
    width: 100vw;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
    .apply_container {
        width: 552px;
        
    }
    .title_meia{
            font-size: 24px !important;
            margin:20px !important;
        }

}
</style>

<style>
.van-cell{
    display: flex !important;
    align-items: center !important;
}
.van-radio-group{
    display: flex;
}
.van-radio{
    margin:0 50px;
}
</style>


// WEBPACK FOOTER //
// findTicket.vue?4f5b4b06